<template>
    <div>
        <carousel
                :scrollPerPage="true"
                :autoplay="true"
                :autoplayTimeout="5000"
                :autoplayHoverPause="false"
                :per-page="1"
                :loop="true"
                :navigationEnabled="true"
                :mouse-drag="true"
                :paginationEnabled="false"
                :speed="600"
                class="home"
        >
                <slide v-for="(item, index) in fields.homepage_banner" :key="'banner-item-' + index" class="slider__item">
                    <section class="slider__media banner-bg desktop m-aside scene_element scene_element--fadein" :style="{ backgroundImage: 'url(' + item.image.url + ')' }"></section>

                    <section class="slider__media banner-bg iphone portrait" :style="{ backgroundImage: 'url(' + item.image.iphone_portrait.url + ')' }"></section>
                    <section class="slider__media banner-bg iphone landscape" :style="{ backgroundImage: 'url(' + item.image.iphone_landscape.url + ')' }"></section>

                    <section class="slider__media banner-bg ipad portrait" :style="{ backgroundImage: 'url(' + item.image.ipad_portrait.url + ')' }"></section>
                    <section class="slider__media banner-bg ipad landscape" :style="{ backgroundImage: 'url(' + item.image.ipad_landscape.url + ')' }"></section>

                    <section class="slider__media banner-bg ipadPro portrait" :style="{ backgroundImage: 'url(' + item.image.ipad_pro_portrait.url + ')' }"></section>
                    <section class="slider__media banner-bg ipadPro landscape" :style="{ backgroundImage: 'url(' + item.image.ipad_pro_landscape.url + ')' }"></section>
                    <div class="banner-content container">
                        <div class="container">
                            <h2 class="banner-title">
                                {{ $prismic.richTextAsPlain(item.title) }}
                            </h2>
                            <!-- Template for page tagline -->
                            <p class="banner-description">{{ $prismic.richTextAsPlain(item.tagline) }}</p>
                        </div>
                        <!--    {{ $prismic.richTextAsPlain(item.button_label) }} -->
                    </div>
                </slide>
        </carousel>
    </div>
</template>

<script>
    export default {
        name: 'Banner',
        data () {
            return {
                fields: {
                    homepage_banner: [
                    ]
                }
            };
        },
        methods: {
            // This is an example query, the important part is above.
            getBanner () {
                this.$prismic.client.getSingle('home')
                    .then((document) => {
                        this.fields.homepage_banner = document.data.homepage_banner;
                        const image = document.data.image

                    })
            }
        },
        created () {
            this.getBanner();
        }
    };
</script>
<style lang="scss">
    .banner-bg  {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        top: 0;
        left: 0;
        background-position-y: center;
        /*transition:all .8s cubic-bezier(0.645, 0.045, 0.355, 1);*/
        transform: matrix(1, 0, 0, 1, 0, 0);
        transform-origin: center center 0;
        margin-bottom: 2.75em;
    }
    .home .banner-bg {
        height: 70vh;
        margin-bottom: 0;
    }
    .banner-content.container {
        animation-name: slide-up;
        animation-duration: 1s;
    }
    @media (max-width: 767px) {
        .banner-content.container {
            top: 50vh;
            padding: 0;
        }
        .banner-title, .banner-description {
            width:100%;
        }
    }
    .VueCarousel-inner {
        position: relative;
        width: 100vw;
        height: 70vh;
        top: 0;
        left: 0;
        z-index: 0
    }
    .slider__item {
        cursor: pointer
    }
    .slider__media {
        width: 100%;
        height: 100%;
        will-change: transform
    }
    .slider__media--img {
        background-size: cover;
        background-position: 50%;
        background-repeat: no-repeat;
    }
    .VueCarousel {
        & .VueCarousel-navigation {
            position: absolute;
            right: 200px;
            z-index: 1;
            top: 60%;
            margin: auto;
            -webkit-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
            height: 50px;
            @media (max-width: 768px){
                top: 80%;
                right: 38%;
            }
            &--animating {
                pointer-events: none;
            }
            & .VueCarousel-navigation-button {
                width: 50px;
                height: 50px;
                background: rgba(0, 0, 0, 0.4);
                border-radius: 50%;
                position: relative;
                color: #fff;
                text-indent: -99999px;
                &:focus {
                    outline: 0;
                }
                &:after {
                    content: "";
                    text-indent: 0;
                    display: block;
                    font-family: 'Concert One', sans-serif;
                    font-size: 30px;
                    position: absolute;
                    top: 5px;
                    left: 17px;
                }
                &.VueCarousel-navigation-prev {
                    &:after {
                        content: "<";
                    }
                }
                &.VueCarousel-navigation-next {
                    &:after {
                        content: ">";
                    }
                }
            }
        }
        & .VueCarousel-navigation-button:hover .slider__navBtnBg {
            opacity: 1;
        }
    }
    .slider__wrapper {
        max-width: 1744px;
        width: calc(100% - 240px);
        padding: 0 110px;
        padding-right: 75px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 100%;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center
    }
    .slider__text {
        color: #fff;
        will-change: transform
    }
    .slider__title {
        margin-top: 6px
    }
    .slider__description {
        margin-top: 12px
    }
</style>
